import React, {Component} from 'react';
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";

import { withRouter } from "react-router";

import {
  Button,
} from "react-bootstrap";

import { affiliateWidget } from "../../../redux/actions/frontActions";
import noImg from "../../../img/no_img.jpg";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "../../../slider/slider-animations.css";
import "../../../slider/styles.css";

let isLoading = true;
let affiliateID;

const history = createBrowserHistory();

class Affiliate extends Component {

	constructor(props) {
		super(props);
		this.state = {
			widgetImage: '',
			affiliateID: '',
			message:'',
		}
	}

	componentWillMount(){

		let affiliateID = this.props.route.match.params.affiliateID ? this.props.route.match.params.affiliateID : ''; 
		if(affiliateID){
  		isLoading = "true";
  		this.setState({ affiliateID: affiliateID });
			this.props.affiliateWidget(affiliateID);
		}
	}

   componentWillReceiveProps(nextProps) { 
	    if (this.props.widgetImage !== nextProps.widgetImage) {
	      if (nextProps.widgetImage) {
	        isLoading = "false";
	        if(nextProps.widgetImage.data) {
	        	this.setState({ widgetImage: nextProps.widgetImage.data.deals});
	        } else {
	        	this.setState({ message: 'Deal Not Available.'});
	        }
	        
	        if (nextProps.widgetImage.message && nextProps.widgetImage.response && nextProps.widgetImage.response=="error") {
	          this.setState({ message: nextProps.widgetImage.message});
	        }
	      }
	    }
   }

	render() {
		const { widgetImage } = this.state;
		return (
			<React.Fragment>
			    {isLoading == "true" ? (
		          <div className="loader">
		            <p className="loading-message">
		              <i>Loading...</i>
		            </p>
		            <div className="spinner">
		              <div className="dot1" />
		              <div className="dot2" />
		            </div>
		          </div>
		        ) : (
		          ""
		        )}
				{(widgetImage) &&
					<Slider className="slider-wrapper" autoplay={2000} infinite={true} style={{height: '100%', display: 'flex',  justifyContent:'center', alignItems:'center'}}>
						{widgetImage.map((data, key) => 
		        		<div
	                key={key}
	                className="slider-content"
	                style={{
	                  'background': `url('${data.image ? data.imageurl +''+ data.image : noImg}') no-repeat center center`
	                }}
	              >
	                <div className="inner">
	                  <h3 style={{ fontSize:'6vw', color:'#fff' }}>{data.dealText}</h3><br/>
	                  <a className="btn btn-success" href={`${window.location.origin}/deals-detail/${data.dealID}-${data.legalName.toLowerCase().trim().split(/\s+/).join('-')}/${this.state.affiliateID}`} target="_blank" >Click Here</a>
	                </div>
	              </div>
		        	)	
						}
	        </Slider>
    	  }
    	  {(this.state.message) &&
					<div style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
						<h1>{this.state.message}</h1>
	        </div>
    	  }
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
  return {
    widgetImage: state.frontReducer.widgetImage,
    error: state.frontReducer.error
  };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {
    affiliateWidget
  })
)(Affiliate);



// WEBPACK FOOTER //
// ./src/app/views/frontend/Affiliate/Affiliate.js